import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "template"];

  add() {
    const item = this.templateTarget.content.firstElementChild.cloneNode(true);
    this.listTarget.insertBefore(item, this.listTarget.lastElementChild);
  }

  remove(event) {
    event.currentTarget.closest("[data-brand-colors-target='item']").remove();
  }

  syncColor(event) {
    event.target.closest("div").style.backgroundColor = event.target.value;
  }
}
